import script from "./DetalhesPedidoVendaCompleto.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalhesPedidoVendaCompleto.vue?vue&type=script&setup=true&lang=js"

import "./DetalhesPedidoVendaCompleto.vue?vue&type=style&index=0&id=f2c9f218&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2c9f218"]])

export default __exports__